
























import VueOptions from '@utils/VueOptions'
import LoadingIndicator from '@components/LoadingIndicator'
import WizardService from '@services/Wizard'
import WizardRoutes from './routes'

settings =
  name: 'OrganizerTransferWizard'

  resources:
    item:
      resourceName: 'organizer'
      slug: 'organizers/:organizerId/edit'

    organizers:
      resourceName: 'organizers'
      slug: 'suppliers/:topOrgId/organizers'
      fetch: false
      params:
        limit: 100

  vue:
    props: []
    mixins: [WizardService.wizard()]

    components: {
      LoadingIndicator,
    }

    data: ->
      form: @resetForm()

    computed:
      organizer: ->
        @prime.item

      topOrgId: ->
        @organizer?.supplier?.id

      wizardRoutes: ->
        WizardRoutes

      enabledRoutes: ->
        @wizardRoutes

    methods:
      onLoadPrimeCompleted: (resourceKey) ->
        @fetch 'organizers' if resourceKey is 'item'

      resetForm: ->
        @form =
          to_email: null
          type: null
          find_replace_all: true
          recess_verify: false

      setSameAccount: ->
        @form.type = 'same_account'

      setDifferentAccount: ->
        @form.type = 'different_account'
        @form.recess_verify = @organizer.recess_verified

      transfer: ->
        @triggerResource 'item', 'transfer', @form
      onItemTransfer: (payload, data) ->
        @$router.push({ name: 'OrganizerShowPage', params: { organizerId: data.id } })

    watch:
      activeStep: ->
        container = document.querySelector '.wizard'
        @scrollElementTo container.parentElement

export default VueOptions.vue settings
